var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAreaMap = function SvgAreaMap(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8284 4.32964C19.0411 4.48676 19.1666 4.73551 19.1666 4.99997V16.6667C19.1666 17.0325 18.928 17.3556 18.5784 17.4632L13.1617 19.1298C13.0075 19.1773 12.8428 19.1789 12.6877 19.1346L7.09205 17.5359L1.91166 19.1298C1.6589 19.2076 1.38423 19.1608 1.1715 19.0037C0.958776 18.8466 0.833252 18.5978 0.833252 18.3333V6.66664C0.833252 6.3008 1.07185 5.97774 1.42152 5.87016L6.8382 4.20348C6.99241 4.15604 7.15707 4.15437 7.31221 4.1987L12.9078 5.79745L18.0882 4.20348C18.341 4.12571 18.6157 4.17253 18.8284 4.32964ZM7.09205 5.86916L2.49992 7.28212V17.205L6.8382 15.8702C6.99241 15.8227 7.15707 15.8211 7.31221 15.8654L12.9078 17.4641L17.5 16.0512V6.12827L13.1617 7.46312C13.0075 7.51057 12.8428 7.51224 12.6877 7.46791L7.09205 5.86916Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91667 5V16.6667H6.25V5H7.91667Z",
    fill: "#8290A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7499 6.66669V18.3334H12.0833V6.66669H13.7499Z",
    fill: "#8290A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9462 8.88902C14.5734 7.2368 14.5734 4.55802 12.9462 2.90579C11.319 1.25357 8.68083 1.25357 7.05364 2.90579C5.42645 4.55802 5.42645 7.2368 7.05364 8.88902L9.99993 11.6667L12.9462 8.88902Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45999 2.32107C8.41362 0.337393 11.5864 0.337393 13.54 2.32107C15.4867 4.29768 15.4867 7.49719 13.54 9.47379C13.5328 9.48113 13.5254 9.48834 13.5179 9.4954L10.5717 12.273C10.2506 12.5757 9.74938 12.5757 9.42837 12.273L6.48208 9.4954C6.47458 9.48834 6.46722 9.48113 6.45999 9.47379C4.51334 7.49719 4.51334 4.29768 6.45999 2.32107ZM12.3526 3.49056C11.0518 2.16979 8.94822 2.16979 7.64747 3.49056C6.34316 4.81493 6.33975 6.96518 7.63723 8.29387L10 10.5214L12.3628 8.29387C13.6603 6.96518 13.6569 4.81493 12.3526 3.49056Z",
    fill: "#8290A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.08332C10.6904 7.08332 11.25 6.52367 11.25 5.83332C11.25 5.14296 10.6904 4.58331 10 4.58331C9.30965 4.58331 8.75 5.14296 8.75 5.83332C8.75 6.52367 9.30965 7.08332 10 7.08332Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAreaMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/area-map.d2aeb982.svg";
export { ForwardRef as ReactComponent };